<template>
  <div>
    <div class="Section0" style="layout-grid:15.6000pt;" v-if="!this.expired">

<!--      <HelloWorld msg="Welcome to Your Vue.js App"/>-->
      <confirm-info :genQcode=false v-if="infoType=='report'"></confirm-info>
      <confirm-info-shenqing-beian :genQcode=false v-else-if="infoType=='applybeian'" @checkupfile="MethodIsUpfile"></confirm-info-shenqing-beian>
      <confirm-info-shenqing :genQcode=false v-else></confirm-info-shenqing>
      <p align="center" style="margin-top: 20px;">
        <a-button type="primary"  size="large" @click="gotoSign" style="width: 300px;height: 60px;font-size: 40px;">{{nextbuttonText}}</a-button>
      </p>
    </div>
    <div v-else>
      <b>{{msg}}</b>
    </div>
  </div>
</template>
<script>
  import confirmInfo from './components/modules_agreement/UapsBudgetAddmainForm0'
  import confirmInfoShenqing from './components/modules_yssq/UapsBudgetAddmainForm'
  import confirmInfoShenqingBeian from './components/modules_yssqba/UapsBudgetAddmainForm'
  import {getAction} from '@/api/manage'
  export default {
    name: 'signExpert',
    components: {confirmInfo,confirmInfoShenqing,confirmInfoShenqingBeian},
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: () => {
        },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        expired:false,
        msg:"已经超时无法签字",
        icon:'',
        infoType:'apply',
        yanshou:{
        },
        yanshouOptions:[{value:'1',label:'自行验收'},{value:'2',label:'委托验收'}],
        nextbuttonText:"去签字",
        needUpload:"0"
      }
    },
    created(){
      //this.needUpload=this.GetQueryString("needup");
      this.infoType=this.GetQueryString("infoType");
      let field=this.GetQueryString("field");
      if(this.infoType==null || field==null){
        this.expired=true;
      }
      // if(this.infoType=="applybeian" && field=="sqbeian_chuyan"){
      //   this.nextbuttonText="下一步";
      // }
      // let startTime = moment(moment.unix(this.GetQueryString('time')).toDate());
      // let endTime = moment(new Date().getTime());;
      // let tdiff=moment(endTime).diff(moment(startTime),'minutes');
      // if(tdiff>=2){
      //   this.expired=true;
      //   this.$message.error("已经超时无法签字");
      // }

    },
    mounted() {

    },
    methods:{
      async gotoSign(){
        let filed=this.GetQueryString("field");
        let id=this.GetQueryString("id");
        let planId=this.GetQueryString("planId");
        let accId=this.GetQueryString("accId");
        let orgCode=this.GetQueryString("orgCode");

          planId=accId
          //this.$router.push('/expertSign?projectId='+id+'&field='+filed);
          let url="/uaps_ele_signature/uapsEleSignature/listmobile";

          //工程监理意见
          let params={projectId:id,filedName:filed,accId:accId,sysOrgCode:orgCode};
          getAction(url, params).then((res) => {
              res=res.data;
              if (res.success) {
                  if(res.result.records.length>0){
                      //工程监理意见签字
                      if((filed=="sqputong_jiandu" || filed=="sqputong_chuyanFuZheRen" || filed=="sqputong_chuyanDanWeiFuZheRen" || filed=="baogao_yiyizuzhang" || filed=="baogao_zccfuzheren" || filed=="sqbeian_chuyanFuZheRen" || filed=="sqbeian_chuyanDanWeiFuZheRen" || filed=="sqbeian_zichanchuFuZheRen") && res.result.records.length>=1){
                          this.$message.error("签字已经结束");
                          this.expired=true;
                          this.msg="签字已经结束";
                      }
                      else if((filed=="sqputong_chuyan" || filed=="sqbeian_chuyan") && res.result.records.length>=3){
                          // console.log(filed);
                          // console.log("length:"+res.result.records.length);
                          this.$message.error("签字已经结束");
                          this.expired=true;
                          this.msg="签字已经结束";
                      }
                      else if(this.infoType=="applybeian" && filed=="sqbeian_chuyan" && this.needUpload=="1"){
                          this.$router.push({ name: 'uppicvideo', params: {projectId: id,field:filed,planId:planId}});
                      }
                      else{
                          console.log({projectId: id,field:filed,planId:planId,sysOrgCode:orgCode});
                          this.$router.push({ name: 'sign', params: {projectId: id,field:filed,planId:planId,sysOrgCode:orgCode}});
                      }
                  }
                  else if(this.infoType=="applybeian" && filed=="sqbeian_chuyan" && this.needUpload=="1"){
                      this.$router.push({ name: 'uppicvideo', params: {projectId: id,field:filed,planId:planId}});
                  }
                  else{
                      //this.$router.push('/sign');
                      this.$router.push({ name: 'sign', params: {projectId: id,field:filed,planId:planId,sysOrgCode:orgCode}});
                  }
              }
              if (res.code === 510) {
                  this.$message.warning(res.message)
              }
          })

          // const path = window.location.pathname
          // let ticket=await getAction(`/api/anon/ticket?path="${encodeURIComponent(path)}`).then((res) => {
          //     res=res.data;
          //     if (res.success) {
          //         return res.result;
          //     }else{
          //         return "error"
          //     }
          // })
          // if(ticket!="error"){
          //     planId=accId
          //     //this.$router.push('/expertSign?projectId='+id+'&field='+filed);
          //     let url="/uaps_ele_signature/uapsEleSignature/listQianming";
          //
          //     //工程监理意见
          //     let params={projectId:id,filedName:filed,accId:accId,sysOrgCode:orgCode};
          //     getAction(url, params).then((res) => {
          //         res=res.data;
          //         if (res.success) {
          //             if(res.result.records.length>0){
          //                 //工程监理意见签字
          //                 if((filed=="sqputong_jiandu" || filed=="sqputong_chuyanFuZheRen" || filed=="sqputong_chuyanDanWeiFuZheRen" || filed=="baogao_yiyizuzhang" || filed=="baogao_zccfuzheren" || filed=="sqbeian_chuyanFuZheRen" || filed=="sqbeian_chuyanDanWeiFuZheRen" || filed=="sqbeian_zichanchuFuZheRen") && res.result.records.length>=1){
          //                     this.$message.error("签字已经结束");
          //                     this.expired=true;
          //                     this.msg="签字已经结束";
          //                 }
          //                 else if((filed=="sqputong_chuyan" || filed=="sqbeian_chuyan") && res.result.records.length>=3){
          //                     // console.log(filed);
          //                     // console.log("length:"+res.result.records.length);
          //                     this.$message.error("签字已经结束");
          //                     this.expired=true;
          //                     this.msg="签字已经结束";
          //                 }
          //                 else if(this.infoType=="applybeian" && filed=="sqbeian_chuyan" && this.needUpload=="1"){
          //                     this.$router.push({ name: 'uppicvideo', params: {projectId: id,field:filed,planId:planId}});
          //                 }
          //                 else{
          //                     console.log({projectId: id,field:filed,planId:planId,sysOrgCode:orgCode});
          //                     this.$router.push({ name: 'sign', params: {projectId: id,field:filed,planId:planId,sysOrgCode:orgCode}});
          //                 }
          //             }
          //             else if(this.infoType=="applybeian" && filed=="sqbeian_chuyan" && this.needUpload=="1"){
          //                 this.$router.push({ name: 'uppicvideo', params: {projectId: id,field:filed,planId:planId}});
          //             }
          //             else{
          //                 //this.$router.push('/sign');
          //                 this.$router.push({ name: 'sign', params: {projectId: id,field:filed,planId:planId,sysOrgCode:orgCode}});
          //             }
          //         }
          //         if (res.code === 510) {
          //             this.$message.warning(res.message)
          //         }
          //     })
          // }

      },
      MethodIsUpfile(value){
        console.log(value);
        if(value!=true){
          this.needUpload='1';
        }
      },
      gotoSign0(){
        let filed=this.GetQueryString("field");
        let id=this.GetQueryString("id");
        this.$router.push('/expertSign?projectId='+id+'&field='+filed);
      },
      GetQueryString(name)
      {
        var a = decodeURI(window.location.search)
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = a.substr(1).match(reg);
        if(r!=null)return unescape(r[2]); return null;
      },
      Base64ToImage(base64){
        let imgBase64='data:image/jpg;base64,'+base64.replace(/[\r\n]/g,'');
        return imgBase64;
      },
    }
  }
</script>


<style scoped>
  .inputclass {
    border: none;
    outline: none
  }
  p.MsoNormal{
    mso-style-name:正文;
    mso-style-parent:"";
    margin:0pt;
    margin-bottom:.0001pt;
    font-family:'Times New Roman';
    mso-fareast-font-family:宋体;
    font-size:10.0000pt;
  }

  span.10{
    font-family:等线;
  }

  span.15{
    font-family:等线;
    font-size:9.0000pt;
  }

  span.16{
    font-family:等线;
    font-size:9.0000pt;
  }

  p.MsoHeader{
    mso-style-name:页眉;
    mso-style-noshow:yes;
    margin:0pt;
    margin-bottom:.0001pt;
    border-bottom:1.0000pt solid windowtext;
    mso-border-bottom-alt:0.7500pt solid windowtext;
    padding:0pt 0pt 1pt 0pt ;
    layout-grid-mode:char;
    mso-pagination:none;
    text-align:center;
    font-family:等线;
    mso-bidi-font-family:'Times New Roman';
    font-size:9.0000pt;
    mso-font-kerning:1.0000pt;
  }

  p.MsoFooter{
    mso-style-name:页脚;
    mso-style-noshow:yes;
    margin:0pt;
    margin-bottom:.0001pt;
    layout-grid-mode:char;
    mso-pagination:none;
    font-family:等线;
    mso-bidi-font-family:'Times New Roman';
    font-size:9.0000pt;
    mso-font-kerning:1.0000pt;
  }

  span.msoIns{
    mso-style-type:export-only;
    mso-style-name:"";
    text-decoration:underline;
    text-underline:single;
    color:blue;
  }

  span.msoDel{
    mso-style-type:export-only;
    mso-style-name:"";
    text-decoration:line-through;
    color:red;
  }

  table.MsoNormalTable{
    mso-style-name:普通表格;
    mso-style-parent:"";
    mso-style-noshow:yes;
    mso-tstyle-rowband-size:0;
    mso-tstyle-colband-size:0;
    mso-padding-alt:0.0000pt 5.4000pt 0.0000pt 5.4000pt;
    mso-para-margin:0pt;
    mso-para-margin-bottom:.0001pt;
    mso-pagination:widow-orphan;
    font-family:'Times New Roman';
    font-size:10.0000pt;
    mso-ansi-language:#0400;
    mso-fareast-language:#0400;
    mso-bidi-language:#0400;
  }
  @page{mso-page-border-surround-header:no;
    mso-page-border-surround-footer:no;}@page Section0{
    margin-top:72.0000pt;
    margin-bottom:72.0000pt;
    margin-left:90.0000pt;
    margin-right:90.0000pt;
    size:595.3000pt 841.9000pt;
    layout-grid:15.6000pt;
  }
  div.Section0{page:Section0;}
</style>
